import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {signUp} from "utils/api";
import {SpinnerButton} from 'common/SpinnerButton';
import './style.css';
import {AuthLayout} from "./AuthLayout";
import {InputWithError} from "../../common/InputWithError";

export const SignUp = () => {
    const [submitting, setSubmitting] = useState(false);
    const [email, setEmail] = useState('');
    const [isEmailSent, setIsEmailSent] = useState(false);
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        localStorage.removeItem('token');
    }, []);

    useEffect(() => {
        setErrors(null);
    }, [email]);

    const onSubmit = async () => {
        setSubmitting(true);
        setErrors(null);

        try {
            await signUp(email, (window.location.origin + '/registration/confirm'))

            setIsEmailSent(true);
        } catch (err) {
            setErrors({errors: {'email': [{'message': err.message}]}});
        }

        setSubmitting(false);
    };

    const signUpForm = () => {
        return (
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
                <div className="text-center w-100 px-3 px-md-5">
                    <div className="login-box shadow-sm">
                        {!isEmailSent ? (
                            <>
                                <h4 className="mb-3 login-title" style={{color: '#6EB5D2'}}>Ready for faster insights?</h4>
                                <h4 className="mb-5 login-title">Start your free team trial:</h4>
                                <div className="mb-4 text-start">
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <InputWithError
                                        id="email"
                                        name="email"
                                        value={email}
                                        type="email"
                                        onChange={setEmail}
                                        errorObj={errors}
                                        autoComplete="off"
                                        className="form-control rounded-pill"
                                    />
                                </div>
                                <div className="mt-5 mb-6 text-start">
                                    <SpinnerButton
                                        color="primary"
                                        block
                                        disabled={email.length < 1}
                                        onClick={onSubmit}
                                        submitting={submitting}
                                        title="Submit"
                                        className="text-bold rounded-pill"
                                    />
                                </div>
                                <div className="mt-5">
                                    Already have an account?&nbsp;&nbsp;
                                    <Link className="underline-important" to="/signin">
                                        Sign In
                                    </Link>
                                </div>
                            </>
                        ) : (
                            <>
                                <h4 className="mb-3 login-title">Complete Registration</h4>
                                <p className="mb-4 mt-3">
                                    We just emailed a confirmation link to {email}.
                                </p>
                                <div>
                                    Return to &nbsp;
                                    <Link className="underline-important" to="/signin">
                                        Log In
                                    </Link> &nbsp; page
                                </div>
                            </>
                        )}

                    </div>
                </div>
            </div>
        )
    }

    return <AuthLayout authForm={signUpForm()}/>
};
